// extracted by mini-css-extract-plugin
export default {"eruditCoursesGrid":"EducationList_eruditCoursesGrid__+WRRK"};